import { smartformDetail } from './projects/personal/smartformDetail';
import { sapoPosDetail } from './projects/team/sapoPosDetail';
import { portfolioDetail } from './projects/personal/portfolioDetail';
import { socialAppDetail } from './projects/team/socialAppDetail';
import { clipAppDetail } from './projects/personal/clipAppDetail';
import { shopPageDetail } from './projects/personal/shopPageDetail';

// Mảng danh sách các dự án
export const projects = [
    {
        id: 'smartform',
        title: 'SmartForms - Hệ thống quản lý form đa năng',
        shortDescription:
            'Nền tảng form đa năng với khả năng tùy biến cao, phục vụ nhiều mục đích khác nhau như khảo sát, thi trực tuyến, bán hàng, điểm danh và phân tích dữ liệu',
        thumbnail: '/assets/images/projects/smartforms/smartforms-intro.png',
        category: 'Ứng dụng Web',
        tags: [
            'ReactJS',
            'Ant Design',
            'Redux',
            'Spring Boot',
            'Spring Webflux',
            'Spring Security',
            'Spring AOP',
            'Spring Cloud',
            'Python',
            'Flask',
            'Kafka',
            'MinIO',
            'FCM',
            'WebSocket',
            'Elasticsearch',
            'Redis',
            'MySQL',
            'JWT',
            'OAuth2',
            'DevSecOps',
        ],
        completedDate: '2024',
        client: 'Đồ án tốt nghiệp',
        role: 'Full Stack Developer',
        previewLink: 'https://smartform.manhphuong.site',
        youtubeLink: 'https://www.youtube.com/watch?v=bzNPb22us_Q',
        githubLink: 'https://github.com/Manh-Phuong/DATN',
        type: 'personal', // Dự án cá nhân
    },
    {
        id: 'sapo-pos',
        title: 'POS - Hệ thống quản lý bán hàng tại quầy',
        shortDescription:
            'Hệ thống quản lý bán hàng toàn diện giúp các cửa hàng bán lẻ tối ưu hóa quy trình bán hàng, quản lý hàng tồn kho, chăm sóc khách hàng và phân tích kinh doanh',
        thumbnail: '/assets/images/projects/sapo-pos/thumbnail.jpg',
        category: 'Ứng dụng Web',
        tags: [
            'ReactJS',
            'Material UI',
            'Redux Toolkit',
            'Spring Boot',
            'Spring Security',
            'JWT',
            'MySQL',
            'Cloudinary',
            'RESTful API',
            'Responsive Design',
            'POS System',
        ],
        completedDate: '2023',
        client: 'Nhóm dự án thực tập',
        role: 'Full Stack Developer',
        previewLink: 'https://sapo-pos.example.com',
        youtubeLink: 'https://www.youtube.com/watch?v=XJD6l26ly4U',
        // githubLink: 'https://github.com/Manh-Phuong/sapo-pos',
        type: 'team', // Dự án nhóm
    },
    {
        id: 'social-app',
        title: 'Social App - Ứng dụng mạng xã hội di động',
        shortDescription:
            'Ứng dụng mạng xã hội di động clone Facebook với tính năng độc đáo là hệ thống xu để khuyến khích nội dung chất lượng và xử lý nội dung không phù hợp',
        thumbnail: '/assets/images/projects/social-app/thumbnail.jpg',
        category: 'Ứng dụng Di động',
        tags: [
            'React Native',
            'Expo',
            'Redux Toolkit',
            'React Navigation',
            'Mobile App',
            'Cross-platform',
            'Social Network',
            'Agile',
        ],
        completedDate: '2023',
        client: 'Đồ án môn học',
        role: 'Mobile Developer',
        // previewLink: 'https://social-app.example.com',
        youtubeLink: 'https://www.youtube.com/watch?v=5IF0wDXgXv0',
        githubLink: 'https://github.com/username/social-app',
        type: 'team', // Dự án nhóm
    },
    {
        id: 'portfolio',
        title: 'Portfolio Website - Trang giới thiệu cá nhân',
        shortDescription:
            'Website portfolio cá nhân với thiết kế hiện đại, responsive và hiệu ứng mượt mà, giúp giới thiệu bản thân và dự án một cách chuyên nghiệp',
        thumbnail: '/assets/images/projects/portfolio/thumbnail.jpg',
        category: 'Ứng dụng Web',
        tags: ['ReactJS', 'Tailwind CSS', 'SCSS', 'Ant Design', 'Redux Toolkit', 'Vercel'],
        completedDate: '2025',
        client: 'Cá nhân',
        role: 'Frontend Developer',
        previewLink: 'https://portfolio.manhphuong.site/',
        // githubLink: 'https://github.com/username/portfolio',
        type: 'personal',
    },
    {
        id: 'clip-app',
        title: 'Clip App - Clone giao diện TikTok',
        shortDescription:
            'Dự án cá nhân clone giao diện của ứng dụng TikTok, tập trung vào việc tái tạo trải nghiệm người dùng và các tính năng giao diện chính của nền tảng chia sẻ video phổ biến này',
        thumbnail: '/assets/images/projects/clip-app/thumbnail.jpg',
        category: 'Ứng dụng Web',
        tags: ['ReactJS', 'SCSS', 'JavaScript', 'Responsive Design', 'UI/UX', 'Git'],
        completedDate: '2022',
        client: 'Cá nhân',
        role: 'Frontend Developer',
        previewLink: 'https://manh-phuong.github.io/clone_tiktok/',
        // youtubeLink: '',
        githubLink: 'https://github.com/Manh-Phuong/clone_tiktok',
        type: 'personal', // Dự án cá nhân
    },
    {
        id: 'shop-page',
        title: 'Shop Page - Clone giao diện Shopee',
        shortDescription:
            'Dự án clone giao diện trang danh sách sản phẩm của Shopee, tập trung vào việc tái tạo trải nghiệm người dùng bằng HTML, CSS và JavaScript thuần',
        thumbnail: '/assets/images/projects/shop-page/thumbnail.jpg',
        category: 'Ứng dụng Web',
        tags: ['HTML5', 'CSS3', 'JavaScript', 'Responsive Design', 'E-commerce', 'UI/UX'],
        completedDate: '2022',
        client: 'Cá nhân',
        role: 'Frontend Developer',
        previewLink: 'https://manh-phuong.github.io/clone-shoppe/',
        githubLink: 'https://github.com/Manh-Phuong/clone-shoppe',
        type: 'personal', // Dự án cá nhân
    },
];

// Chi tiết của từng dự án, có thể truy xuất bằng id
export const projectDetails = {
    smartform: smartformDetail,
    'sapo-pos': sapoPosDetail,
    'clip-app': clipAppDetail,
    'social-app': socialAppDetail,
    portfolio: portfolioDetail,
    'shop-page': shopPageDetail,
};
